<template>
  <div class="product">
    <!--添加-->
    <div class="common-level-rail">
      <el-form :inline="true" :model="formSearch" size="small">
        <el-form-item label="类型筛选">
          <el-button-group>
            <el-button @click="changeTypeFunc('')">不限</el-button>
            <el-button :type="formSearch.type == item.key_name ? 'primary' : ''" plain v-for="(item, index) in typeData" :key="index" @click="changeTypeFunc(item.key_name)">{{item.name}}</el-button>
          </el-button-group>
        </el-form-item>
      </el-form>

      <el-button size="small" type="primary" @click="openPopup('add')" icon="el-icon-plus">添加</el-button>
      <el-button size="small" type="primary" @click="openPopup('batch')" icon="el-icon-check">批量操作</el-button>
    </div>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-input
          placeholder="输入关键字进行过滤"
          v-model="filterText">
        </el-input>
        <el-tree 
        stripe
        class="mt10"
        :data="tableData" show-checkbox node-key="category_id"
        ref="tree"
        default-expand-all
        :filter-node-method="filterNode"
        :props="defaultProps" 
        @check="handleCheckChange"
        :draggable="false"
        @node-drop="handleDrop"
        >
          <div class="tree-node" slot-scope="{data}">
            <div>
              <el-tag type="info" class="style1-tag" v-if="data.level==1 && typeData[data.type]">{{ typeData[data.type].name }}</el-tag>
              <el-tag type="info" class="style1-tag" v-if="data.level==2 && data.type == 60">试卷</el-tag>
              <span :class="data.status == 0 ? 'text-d-line' : ''">{{ data.name }} ({{ data.category_id }}) </span>
              <span class="red ml10" v-if="data.is_lock == 1">收费</span>
              <el-tag type="info" class="style1-tag" v-if="data.label_id>0">{{ data.label.title }}</el-tag>
            </div>
            
            <span>
              <el-button @click.stop="openPopup('school', data)" type="text" size="small" v-if="data.type==10 && data.level==1">+绑定院校</el-button>
              <el-button @click.stop="openPopup('question', data)" type="text" size="small" v-if="formSearch.type == 60 && data.level==2">
                +自定义组合答题 <span v-if="data.question_ids">({{ data.question_ids.split(',').length }})</span>
              </el-button>
              <el-button @click.stop="addClick(data,'copy')" type="text" size="small">一键复制</el-button>
              <el-button @click.stop="addClick(data,'child')" type="text" size="small">添加子分类</el-button>
              <el-button @click.stop="openPopup('edit', data)" type="text" size="small">编辑</el-button>
              <el-button @click.stop="deleteClick(data)" type="text" size="small">删除</el-button>
            </span>
          </div>
        </el-tree>
      </div>
    </div>

    <!--添加-->
    <Add v-if="show_popup['add']" :open_add="show_popup['add']" :add_type="add_type" :labelData="labelData" :typeData="typeData" :type="formSearch.type" :rawData="rawData" :selectModel="selectModel" @closeDialog="closeDialogFunc($event, 'add')"></Add>

    <!--编辑-->
    <Edit v-if="show_popup['edit']" :open_edit="show_popup['edit']" :labelData="labelData" :typeData="typeData" :rawData="rawData" :selectModel="selectModel" @closeDialog="closeDialogFunc($event, 'edit')"></Edit>

    <!--批量-->
    <Batch v-if="show_popup['batch']" :is_open="show_popup['batch']" :labelData="labelData" :typeData="typeData" :selectModel="selectModel" :ids="ids" @closeDialog="closeDialogFunc($event, 'batch')"></Batch>

    <!--批量-->
    <Question v-if="show_popup['question']" :open_quest="show_popup['question']" :selectModel="selectModel" :formSearch="formSearch" @closeDialog="closeDialogFunc($event, 'question')" @callBackFun="callBackFun"></Question>

    <!--学校-->
    <Diycategory v-if="show_popup['school']" :open_quest="show_popup['school']" :selectModel="selectModel" :formSearch="formSearch" @closeDialog="closeDialogFunc($event, 'school')" @callBackFun="callBackFun"></Diycategory>
  </div>
</template>
<script>
import CategoryApi from '@/api/study/category.js';
import Edit from './part/Edit';
import Add from './part/Add';
import Batch from './part/Batch';
import Question from '@/components/study/Question';
import Diycategory from '@/components/study/Diycategory';
import { deepClone, getTreeIds } from '@/utils/base.js';
export default {
  components: {
    Add,
    Edit,
    Batch,
    Question,
    Diycategory
  },
  data() {
    return {
      /*是否正在加载*/
      loading: true,
      /*筛选搜索*/
      formSearch: {
        /*类型*/
        type: '',
        /*是否收起*/
        pack_up: false,
      },
      /*原始数据*/
      rawData: [],
      /*表格数据*/
      tableData: [],
      /*添加类型*/
      add_type:'',
      /*当前编辑的对象*/
      userModel: {},
      typeData: {},
      labelData: {},
      defaultProps: {
          children: 'children',
          label: 'name'
      },
      /*弹窗*/
      show_popup: {
        add: false,
        edit: false,
        batch: false,
        question: false,
        school: false,
      },
      /*选中的对象*/
      selectModel:{},
      input_type:[],
      multipleSelection: [],
      ids: [],
      filterText: ''
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  created() {
    // 默认
    let type = this.$db.getRouteField(this, 'type');
    if (type) this.formSearch.type = type;
    /*获取列表*/
    this.getTableList();
  },
  methods: {
    handleDrop(draggingNode, dropNode, dropType, ev) {
      console.log('tree drop: ', dropNode.label, dropType);
      console.log(this.tableData);
      console.log(getTreeIds(this.tableData, [], 'category_id'));
    },
    /*过滤*/
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },

    /*监听选中*/
    handleCheckChange(data, checked) {
      this.ids = checked.checkedKeys;
    },

    /*选择类型*/
    changeTypeFunc(e){
      this.formSearch.page = 1;
      this.formSearch.type = e;
      this.$db.setRoute(this, {'type': e});
      this.getTableList();
      this.ids = [];
      this.$refs.tree.setCheckedKeys([]);
    },

    /*是否收起*/
    changePackUpFunc(e) {
      this.forArr(this.tableData, !e);
    },

    /*列表收起*/
    forArr(arr, isExpand) {
      arr.forEach(i => {
        this.$refs.theTable.toggleRowExpansion(i, isExpand);
        if (i.children) {
          this.forArr(i.children, isExpand);
        }
      });
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = self.formSearch;
      CategoryApi.getList(Params, true)
        .then(res => {
          self.loading = false;
          self.rawData = res.data.list;
          self.tableData = res.data.list;
          self.typeData = res.data.type;          
          self.labelData = res.data.label;          
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*打开添加*/
    roleClick(item) {
      this.userModel = item;
      this.open_role = true;
    },

    /*打开添加*/
    addClick(e,type) {
      if(e&&typeof(e)!='undefined'){
        this.add_type=type;
        this.selectModel=deepClone(e);
      }else{
        this.parents_id=0;
      }
      this.show_popup['add'] = true;
    },

    /*打开弹窗*/
    openPopup(name, item){
      this.show_popup[name] = true;
      if (item) this.selectModel = item;
    },

    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      this.show_popup[f] = e.openDialog;
      if (e.type == 'success') {
        this.getTableList();
      }
      this.ids = [];
      this.$refs.tree.setCheckedKeys([]);
    },
    /*回调*/
    callBackFun(e){
      let self = this;
      let item = this.selectModel;
      this.selectModel.question_ids = e.ids.toString();
      CategoryApi.add_question({type:item.type, category_id: item.category_id, ids:e.ids},true)
        .then(data => {
          if (data.code == 1) {
            self.loading = false;
            self.$message({
              message: data.msg,
              type: 'success'
            });
            self.getTableList();
          }
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*删除用户*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm('删除后不可恢复，确认删除该记录吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.loading = true;
          CategoryApi.del({category_id: row.category_id},true)
            .then(data => {
              if (data.code == 1) {
                self.loading = false;
                self.$message({
                  message: data.msg,
                  type: 'success'
                });
                self.getTableList();
              }
            })
            .catch(error => {
              self.loading = false;
            });
        })
        .catch(() => {});
    },
  }
};
</script>
<style>
  .tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }
  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }
  .el-tree-node__content{
    height: 30px;
  }
</style>


// WEBPACK FOOTER //
// src/views/study/category/index.vue